<template>
  <a-modal
      title="添加商品"
      :visible="visible"
      @cancel="onCancel"
      :footer="null"
      :width="725"
  >
    <div class="content-bar">
      <a-form v-bind="formItemLayout">
        <a-form-item label="平台:">
          <a-radio-group name="radioGroup" v-model="formData.pvd">
            <a-radio value="tikTok">
              抖音
            </a-radio>
            <a-radio value="kuaishou">
              快手
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="商品详情完整链接:">
          <a-input placeholder="请输入" v-model="formData.content"  allow-clear></a-input>
        </a-form-item>
        <div class="btns">
          <a-button type="primary" @click="onSubmit">
            提交
          </a-button>
          <a-button style="margin-left: 10px;" @click="onReset">
            重置
          </a-button>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import {goodAdd} from "@/api/merchant-registration";

export default {
  components: {},
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
      },
      visible: false,
      formData: {
        pvd: 'tikTok',
        content: ''
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.formData.content.length == 0) {
        return this.$message.error('请输入商品链接')
      }
      goodAdd(this.formData).then(() => {
        this.$message.success('添加成功')
        this.$emit('on-refresh')
        this.onCancel()
      })
    },
    show() {
      this.visible = true
    },
    onCancel() {
      this.visible = false
      this.formData.content = ''
      this.formData.pvd = 'tikTok'
      this.$emit('onCancel')
    },
    onReset() {
      this.formData.content = ''
    }
  },

}
</script>

<style scoped lang="scss">
.content-bar {
  padding-left: 3%;
  padding-right: 3%;
}

.btns {
  display: flex;
  justify-content: center;
}
</style>
